// extracted by mini-css-extract-plugin
module.exports = {"form":"JxdorVG5oqDJPDmt1lf4Qg=="};